import type { EcommerceItemSource } from '@/entities/analytics';
import type { SearchCriteria } from '@/entities/searchCriteria';
import { SERP_ECOMMERCE_IMPRESSIONS_PAGE_SIZE } from '../config/ecommerce';
import type { SerpProduct } from '../model/types';

export function getSerpEcommerceItem(
  serpProduct: SerpProduct,
  position: number,
  criteria: SearchCriteria,
): EcommerceItemSource | null {
  const product = serpProduct.cheapProduct ?? serpProduct.products.at(0);

  if (!product) return null;

  return {
    hotel: serpProduct.hotel,
    product,
    departureCityName: criteria.fromCity?.name ?? product.departureCity?.name ?? '',
    position,
  };
}

export function getSerpEcommercePage(
  products: readonly SerpProduct[],
  page: number,
  criteria: SearchCriteria,
): EcommerceItemSource[] {
  const start = page * SERP_ECOMMERCE_IMPRESSIONS_PAGE_SIZE;

  return products.slice(start, start + SERP_ECOMMERCE_IMPRESSIONS_PAGE_SIZE).flatMap((serpProduct, index) => {
    const item = getSerpEcommerceItem(serpProduct, start + index, criteria);

    return item ? [item] : [];
  });
}

export function getSerpEcommercePagesCount(renderedCount: number): number {
  return Math.ceil(Math.max(renderedCount, 0) / SERP_ECOMMERCE_IMPRESSIONS_PAGE_SIZE);
}

export function getSerpEcommerceListSignature(listKey: string, products: readonly SerpProduct[]): string {
  const hotelIds = products.map(({ hotel }) => hotel.id).sort((left, right) => left - right);

  return `${listKey}|${hotelIds.join('.')}`;
}
